module.exports = __webpack_public_path__ + "static/media/4931-03.8cf187b6.png";